import GameModel from "../../../core/src/model/GameModel";
import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";
import Configs from "../../vendorConfigs/Configs";

export default class GetSessionRequest implements IRequestBuilder {
    get method() {
      return "POST";
    }
  
    get path() {
        return Configs.game.clientConfig.gameServerApi + "/getsessionresult"
    }
  
    get requestData() {
      return {
        sid: GameModel.sessionID
      }
    }
  }